import { render, staticRenderFns } from "./index.vue?vue&type=template&id=994b0f24&scoped=true"
import script from "./popularQuestions.js?vue&type=script&lang=js&external"
export * from "./popularQuestions.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=994b0f24&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994b0f24",
  null
  
)

export default component.exports